/**
 * API Configuration
 * Quản lý tất cả các API endpoints và cấu hình
 */

// Base API URL từ environment variable
const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

/**
 * API Endpoints
 */
export const API_ENDPOINTS = {
  // Authentication
  AUTH: {
    LOGIN: '/user/login',
    LOGOUT: '/user/logout',
    REFRESH: '/user/refresh',
    PROFILE: '/user/profile',
    CHANGE_PASSWORD: '/user/change-password',
  },

  // Dashboard
  DASHBOARD: {
    DAILY_REPORT: '/dashboard/daily-report',
  },

  // Campaigns
  CAMPAIGNS: {
    LIST: '/campaigns',
    CREATE: '/campaigns',
    UPDATE: '/campaigns',
    DELETE: '/campaigns',
    DETAIL: '/campaigns',
    ANALYTICS: '/campaigns/analytics/',
  },

  // Marketers
  MARKETERS: {
    LIST: '/marketers',
    CREATE: '/marketers',
    UPDATE: '/marketers',
    DELETE: '/marketers',
    DETAIL: '/marketers',
  },

  // Pages
  PAGES: {
    LIST: '/pages',
    CREATE: '/pages',
    UPDATE: '/pages',
    DELETE: '/pages',
    DETAIL: '/pages',
  },

  // Chat History
  CHAT_HISTORY: {
    LIST: '/chat-history',
    DETAIL: '/chat-history',
    TRACE_OTHER_PAGE: '/chat-history/history-other-page',
  },

  // External Sources
  EXTERNAL_SOURCES: {
    LIST: '/external-sources',
    CREATE: '/external-sources',
    UPDATE: '/external-sources',
    DELETE: '/external-sources',
    DETAIL: '/external-sources',
  },

  // Leads
  LEADS: {
    LIST: '/leads',
    CREATE: '/leads',
    UPDATE: '/leads',
    DELETE: '/leads',
    DETAIL: '/leads',
  },

  // Orders
  ORDERS: {
    LIST: '/orders',
    CREATE: '/orders',
    UPDATE: '/orders',
    DELETE: '/orders',
    DETAIL: '/orders',
    CALCULATE_REVENUE: '/calculate-campaign-revenue-by-date',
  },

  // Holidays
  HOLIDAYS: {
    LIST: '/holidays',
    CREATE: '/holidays',
    UPDATE: '/holidays',
    DELETE: '/holidays',
    DETAIL: '/holidays',
  },

  BIGQUERY: {
    PUSH_REVENUE: '/bigquery/push-revenue',
    DELETE_PUSHED_DATA: '/bigquery/delete-pushed-data',
  },
} as const;

/**
 * API Configuration
 */
export const API_CONFIG = {
  BASE_URL: API_BASE_URL,
  TIMEOUT: 10000, // 10 seconds
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000, // 1 second
} as const;

/**
 * Get full URL for an endpoint
 */
export const getApiUrl = (endpoint: string): string => {
  return `${API_BASE_URL}${endpoint}`;
};

/**
 * Get authentication endpoints
 */
export const getAuthEndpoints = () => API_ENDPOINTS.AUTH;

/**
 * Get dashboard endpoints
 */
export const getDashboardEndpoints = () => API_ENDPOINTS.DASHBOARD;

/**
 * Get campaigns endpoints
 */
export const getCampaignsEndpoints = () => API_ENDPOINTS.CAMPAIGNS;

/**
 * Get marketers endpoints
 */
export const getMarketersEndpoints = () => API_ENDPOINTS.MARKETERS;

/**
 * Get pages endpoints
 */
export const getPagesEndpoints = () => API_ENDPOINTS.PAGES;

/**
 * Get chat history endpoints
 */
export const getChatHistoryEndpoints = () => API_ENDPOINTS.CHAT_HISTORY;

/**
 * Get external sources endpoints
 */
export const getExternalSourceEndpoints = () => API_ENDPOINTS.EXTERNAL_SOURCES;

/**
 * Get leads endpoints
 */
export const getLeadsEndpoints = () => API_ENDPOINTS.LEADS;

/**
 * Get orders endpoints
 */
export const getOrdersEndpoints = () => API_ENDPOINTS.ORDERS;

/**
 * Get holidays endpoints
 */
export const getHolidaysEndpoints = () => API_ENDPOINTS.HOLIDAYS;

/**
 * Get bigquery endpoints
 */
export const getBigqueryEndpoints = () => API_ENDPOINTS.BIGQUERY;

export default API_ENDPOINTS;
